import { Campaign as CampaignObjectType } from "@inovitas/infra3dsdk/dist/types/mm/api/utils/campaign";
import { Node } from "@inovitas/infra3dsdk/dist/types/mm/graph/Node";
import { Button, Skeleton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import { topbarStore } from "shared/common/stores/topbarStore";
import CampaignSwitcher from "./CampaignSwitcher";

export interface campaignType {
  campaignID: string;
  description: string;
  date: Date;
  campaignlock: boolean; //currentNode.frame.campaignID == x.id && this.campaignlock ? true : false,
  show_lock: boolean;
}

export default function Campaign() {
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const activeCampaign = defaultStore((state) => state.activeCampaign);
  const changeActiveCampaign = defaultStore(
    (state) => state.changeActiveCampaign
  );

  const changeAnchorDate = topbarStore((state) => state.changeAnchorDate);
  const changeShowHelp = topbarStore((state) => state.changeShowHelp);
  const changeAnchorLang = topbarStore((state) => state.changeAnchorLang);

  const [campaigns, setCampaigns] = useState<campaignType[]>([]);
  const [currentNode, setCurrentNode] = useState<Node>();

  //open date popover
  const handleDateMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    changeAnchorDate(event.currentTarget);
    changeShowHelp(false);
    changeAnchorLang(null);
  };

  //on campaign and node changes save current node and campaigns on state-s
  useEffect(() => {
    if (viewer !== undefined) {
      viewer.on("nodechanged", (node: Node) => {
        setCurrentNode(node);
        if (campaigns.length > 0) {
        }
      });

      viewer.on("campaignschanged", (campaigns: CampaignObjectType[]) => {
        const data = campaigns
          .map((c: CampaignObjectType) => {
            return {
              campaignID: c.id,
              description: c.description,
              date: c.timestamp,
              campaignlock: viewer.campaignlock, //currentNode.frame.campaignID == x.id && this.campaignlock ? true : false,
              show_lock: false, //x.id == currentNode.frame.campaignID ? true : false
            };
          })
          .sort((a, b) => b.date.getTime() - a.date.getTime());
        setCampaigns(data);
      });
    }
  }, [viewer]);

  //when campaigns and current node state-s are changing, set value for active champaign
  useEffect(() => {
    if (campaigns.length > 0 && currentNode !== undefined) {
      changeActiveCampaign(
        campaigns.find(
          (item) => item.campaignID === currentNode.frame.campaignID
        )
      );
    }
  }, [campaigns, currentNode]);

  return (
    <>
      {campaigns.length === 0 && skeleton()}
      {campaigns.length > 0 && activeCampaign !== undefined && (
        <Tooltip
          title={t("tooltip.campaigns")}
          placement="bottom"
          enterDelay={400}
          classes={{ tooltip: "infra3d-buttonDescription" }}
        >
          <Button
            id="infra3d-campaignSwitch"
            className="onboarding-campaignSwitch"
            onClick={handleDateMenuOpen}
            variant="contained"
            sx={{
              borderRadius: "8px",
              padding: "4px 16px",
              color: "white",
              backgroundColor: "darkblue.main",
              textTransform: "none",
              "&:hover": {
                color: "secondary.main",
                backgroundColor: "darkblue.main",
              },
            }}
          >
            <Typography sx={{ fontSize: "13px" }}>
              {activeCampaign.description}
            </Typography>
          </Button>
        </Tooltip>
      )}
      {campaigns.length > 0 && <CampaignSwitcher campaigns={campaigns} />}
    </>
  );
}
export const skeleton = () => {
  return (
    <Button
      disabled
      variant="contained"
      sx={{
        borderRadius: "8px",
        padding: "8px 16px",
        color: "white",
        backgroundColor: "darkblue.main",
        "&:hover": {
          color: "secondary.main",
          backgroundColor: "darkblue.main",
        },
      }}
    >
      <Skeleton
        variant="rectangular"
        sx={{ backgroundColor: "whiteBackground.main", borderRadius: "8px" }}
        width={"80px"}
        height="14px"
      />
    </Button>
  );
};
